import { render } from "./J2012.vue?vue&type=template&id=0d4393ac"
import script from "./J2012.vue?vue&type=script&lang=js"
export * from "./J2012.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__